import React from 'react';
import yagojrhead from '../../../src/assets/images/yagojrhead.png';

const Loading: React.FC = () => {
  return (
    <>
      <style>{`
        @keyframes orbit {
          0% {
            transform: rotate(0deg) translateX(300px) rotate(0deg);
          }
          100% {
            transform: rotate(360deg) translateX(300px) rotate(-360deg);
          }
        }
        .animate-orbit {
          animation: orbit 3s linear infinite;
        }
      `}</style>

      <div className="relative w-[450px] h-[450px] mx-auto mt-20">
        {/* Center image */}
        <img
          src={yagojrhead}
          alt="Center logo"
          className="absolute top-1/2 left-1/2 w-30 h-30 transform -translate-x-1/2 -translate-y-1/2 z-10"
        />

        {/* Orbiting image */}
        <div
          className="absolute top-1/2 left-1/2 w-24 h-24 transform -translate-x-1/2 -translate-y-1/2 animate-orbit"
          style={{ transformOrigin: '200px center' }}
        >
          <img src={yagojrhead} alt="Welcome to yago" className="w-full h-full" />
        </div>
      </div>
    </>
  );
};

export default Loading;
